import React, { useEffect, useState, useRef } from 'react'
import { useLocation, Link } from "react-router-dom";
import './OperatProf.css'
import Header3 from '../../mainLayout/Header/Header3'
import Footer from '../../mainLayout/Footer/Footer'
import ReactStars from "react-rating-stars-component";
import ModalSection from './ModalSection';
import OperatorsDetails from './OperatorsDetails';
import RviewBarsSection from './RviewBarsSection';
import AllReviews from './AllReviews';
import OperatorPictureSection from './OperatorPictureSection';
import axios from 'axios';
import { IMG_SERVER_URL, SERVER_URL } from '../../../ServerUrl';

const OperatorProfile = () => {
    const location = useLocation();
    const { operatorId } = location.state || {};
    const [operator, setOperator] = useState(null);
    const [operatorBusDetail, setOperatorBusDetail] = useState({});
    const [operatorAllReviews, setOperatorAllReviews] = useState([]);
    const [reviewAll, setReviewAll] = useState();
    const countries_array = operator?.countries_array || [];
    const sm_links = operator?.sm_links || [];
    const [feedbackData, setFeedbackData] = useState({ punctuality: 4.5 });
    const year = new Date(operator?.createdAt).getFullYear();
    const reviewSectionRef = useRef(null);

    const scrollToReviews = () => {
        reviewSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };


    const getWebsiteName = (url) => {
        try {
            const hostname = new URL(url).hostname;
            return hostname.replace('www.', '').replace('.com', '');
        } catch (error) {
            console.error("Invalid URL:", url);
            return "Unknown";
        }
    };


    const GetOperator = async () => {
        try {
            const response = await axios.get(`${SERVER_URL}/review/review/${operatorId}`);
            setOperator(response?.data?.operator)
            setOperatorBusDetail(response?.data?.busDetails)
            setOperatorAllReviews(response?.data?.reviews)
            setReviewAll(response?.data)
        } catch (err) {
            console.error('Error saving review:', err);

        }
    };


    const handleFeedbackSuccess = () => {
        GetOperator()
    };

    useEffect(() => {
        GetOperator()
    }, [operatorId])

    // useEffect(() => {
    //     setOperatorId(operator?._id)
    // }, [operator])

    console.log(operatorId, "responseReview", reviewAll)
    return (
        <>
            <div className="operatProfMain">
                <div className='logoSectionOperat'>
                    <div className="operateName">{operator?.companyname}</div>
                    <img src={`${IMG_SERVER_URL}/${operator?.image}`} className='operatorLog' />
                </div>

                <div className='yearsText'>Years in Business: Serving Travelers since {year}</div>
                <div className='averageRateTextArea'>
                    <div className="averageRateText">Average Rating:
                        <ModalSection scrollToReviews={scrollToReviews} operatorAllReviews={operatorAllReviews} reviewAll={reviewAll} />
                    </div>
                    <div className="RatingNumberText">{reviewAll?.averageRating}/5 <span className="basedOnText">(Based on {reviewAll?.totalReviews} reviews)</span> </div>
                </div>
                <div className="operateDetailSection">
                    <div className="operatingCompaanyText">Operating Countries:</div>
                    <div className="operatingCompaanyNameText">
                        {countries_array?.length > 0 ? (
                            countries_array?.map((country, index) => (
                                <span key={index} className="operatingCompaanyNameText">
                                    {country}
                                    {index < countries_array?.length - 1 ? ', ' : ''}
                                </span>
                            ))
                        ) : (
                            <span>No countries yet</span>
                        )}
                    </div>
                </div>
                <div className="operateDetailSection">
                    <div className="operatingCompaanyText">Number of Buses:</div>
                    <div className="operatingCompaanyNameText">{operatorBusDetail?.numberOfBuses}</div>
                </div>
                <div className="operateDetailSection">
                    <div className="operatingCompaanyText">Types of Buses:</div>
                    {operatorBusDetail?.busTypes?.length > 0 ? (
                        operatorBusDetail?.busTypes?.map((country, index) => (
                            <span key={index} className="operatingCompaanyNameText">
                                {country}
                                {index < operatorBusDetail?.busTypes?.length - 1 ? ', ' : ''}
                            </span>
                        ))
                    ) : (
                        <span>No buses yet</span>
                    )}
                </div>
                <OperatorPictureSection operator={operator} />
                <div className="companyDescrp">
                    <div className='desripHead'>{operator?.companyname}’s Description:</div>
                    <div className="descriptDetail">
                        {operator?.about_company}
                    </div>
                </div>
                <OperatorsDetails operator={operator} />
                <div className="operateDetailSection">
                    <div className="operatingCompaanyText">Customer Support Phone Number:</div>
                    <div className="operatingCompaanyNameText">{operator?.companycontactnumber}</div>
                </div>
                <div className="operateDetailSection" ref={reviewSectionRef}>
                    <div className="operatingCompaanyText">Email:</div>
                    <div className="operatingCompaanyNameText">{operator?.support_Email}</div>
                </div>
                <div className="operateDetailSection" >
                    <div className="operatingCompaanyText">Website:</div>
                    <div className="operatingCompaanyNameText">{operator?.website_link}</div>
                </div>
                <div className="operateDetailSection" >
                    <div className="operatingCompaanyText">Social Media Links:</div>
                    <div className="medialINED">
                        {sm_links.map((link, index) => {
                            const websiteName = getWebsiteName(link);
                            console.log(link, websiteName, "websiteName"); // Logging for debugging
                            return (
                                <a
                                    key={index}
                                    href={link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="requiredColor hover:underline"
                                >
                                    {websiteName.charAt(0).toUpperCase() + websiteName.slice(1)}
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className="reviwSection" >
                <div className="whatText">What People Are Saying:</div>
                <div className="reviewOut">
                    <RviewBarsSection operatorAllReviews={operatorAllReviews} reviewAll={reviewAll} />
                    <AllReviews operatorAllReviews={operatorAllReviews} onFeedbackSuccess={handleFeedbackSuccess} />
                </div>
            </div>
        </>
    )
}

export default OperatorProfile
